import $ from 'jquery';

$(document).ready(function () {
  downloadsBlock();
});
function downloadsBlock() {
  $('.js-acf-example-block-block').each(function () {});
}
